import React, { useEffect, useState } from 'react';
import { PrimaryButton, DefaultButton, DialogFooter, Dialog, DialogType } from '@fluentui/react';
import * as formService from '../../form-services/presentation-editor';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { BwjTextField } from '../../../../framework/components/bwj-text-field';

xlationContext('Clone discussion plan modal');

interface ICloneDiscussionPlanModalProps {
  launchModal: {} | undefined;
  onConfirm: () => void;
}

const modalPropsStyles = { main: { maxWidth: 450 } };
const modalProps = {
  isBlocking: true,
  styles: modalPropsStyles,
};

const subscriberId = 'Modal.CloneDiscussionPlanModal';

export const CloneDiscussionPlanModal: React.FunctionComponent<ICloneDiscussionPlanModalProps> = (props) => {
  const { launchModal } = props;
  const [hideModal, setHideModal] = useState(true);
  const formModel = formService.useFormModel(subscriberId);

  useEffect(() => {
    setHideModal(launchModal === undefined);
  }, [launchModal]);

  const dialogContentProps = {
    type: DialogType.normal,
    title: xlate('Copy Discussion Plan'),
  };

  const onConfirm = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid) {
        props.onConfirm();
      }
    });
  }

  return (
    <Dialog
      hidden={hideModal}
      onDismiss={() => setHideModal(true)}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      <BwjTextField
        id={formService.title.id}
        required={true}
        label={xlate('Title')}
        onUpdate={formService.title.onUpdate}
        input={formModel.title}
        filter={/^.{0,50}$/}
      />
      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={xlate('Create copy')} />
        <DefaultButton onClick={() => setHideModal(true)} text={xlate('Cancel')} />
      </DialogFooter>
    </Dialog>
  );
};
